import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@fontsource-variable/manrope";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import { App } from "./app/App.jsx";
import { AppFailureBoundary } from "./app/AppFailureBoundary.jsx";
import { NativeUrlListener } from "./app/NativeUrlListener.jsx";
import { TelegramRuntimeBridge } from "./app/TelegramRuntimeBridge.jsx";
import { AppProviders } from "./app/providers.jsx";
import { captureAcquisition } from "./features/analytics/attribution.js";
import "./styles/reset.css";
import "./design/tokens.css";
import "./design/typography.css";
import "./design/layout.css";
import "./design/motion.css";
import "./styles/global.css";
import "./components/product/product.css";
import "./features/auth/auth.css";
import "./features/profile/profile.css";

// До первого router redirect: гостевой вход может убрать query из адреса.
captureAcquisition(window.location.search);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppFailureBoundary>
      <AppProviders>
        <BrowserRouter>
          <NativeUrlListener />
          <TelegramRuntimeBridge />
          <App />
        </BrowserRouter>
      </AppProviders>
    </AppFailureBoundary>
  </React.StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // PWA-слой не должен блокировать основной web flow.
    });
  });
}
